// persistent storage layer
// from https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }

    const state = JSON.parse(serializedState);
    if (state.expireDate > new Date().getTime()) {
      return state.data;
    } else {
      localStorage.removeItem("state");
      return undefined;
    }
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify({
      data: state,
      expireDate: new Date().getTime() + 7200000 // 2 hpours
    });
    localStorage.setItem("state", serializedState);
  } catch (err) {
    // ignore write errors
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/persister/localStorage.js